import Axios from 'axios';
import Vue from 'vue';
import i18n from '../../i18n';

import { API_HOST } from '../../config/app-const';
import { filtersToQuery } from '../../helpers/filters';

const state = {
  countries: {
    isBusy: false,
    data: null,
    error: null
  }
};

const getters = {
  countries: (state) => {
    if (!state.countries.data) return [];

    return state.countries.data.data.data;
  },
  countriesOptions: (state, getters) => {
    if (!getters.countries || !getters.countries.length) return [];

    return getters.countries.map(item => {
      return { value: item.alpha_2_code, label: item.name };
    });
  },
}

const mutations = {
  LOAD_COUNTRIES_BUSY: (state, payload) => {
    state.countries.isBusy = payload;
  },
  LOAD_COUNTRIES_SUCCESS: (state, payload) => {
    state.countries.data = payload;
    state.countries.error = null;
  },
  LOAD_COUNTRIES_FAIL: (state, payload) => {
    state.countries.data = null;
    state.countries.error = payload;
  }
};

const actions = {
  getCountries: ({ commit, rootState }, { projectId, pagination, filters }) => {
    commit('LOAD_COUNTRIES_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    //in this case in pagination we will only have:searchQuery and perPage since this is a select list
    let query = '';
    if(pagination) {
      query = '?';
      Object.keys(pagination).map((param, i) => {
          query += `${param}=${pagination[param]}${i !== Object.keys(pagination).length - 1 ? '&' : ''}`;
        }
      );
    }

    if (filters) {
      const filtersQuery = filtersToQuery(filters);
      if (filtersQuery != '') {
        query += '&' + filtersQuery;
      }
    }

    return Axios
      .get(`${API_HOST}/analysis/${projectId}/countries${query}`, config)
      .then(response => {
        commit('LOAD_COUNTRIES_SUCCESS', response.data)
        return response.data;
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});

        console.error(error);
        commit('LOAD_COUNTRIES_FAIL', error)
      })
      .finally(() => commit('LOAD_COUNTRIES_BUSY', false));
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};